module.exports = __webpack_public_path__ + "img/logo_all.b9eb1d55.png";